import SEOHead from '@/components/base/SEOHead';
import HeroBanner from './components/HeroBanner';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import LatestUpdates from './components/LatestUpdates';
import CTA from './components/CTA';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '丝袜小说精选合集',
  url: 'https://vipmvpda.cn',
  description: '丝袜小说频道汇聚海量精品原创故事，涵盖都市言情、青春校园、职场情感等多元题材，每日更新最新章节，为喜爱丝袜小说的读者提供极致阅读体验，收藏本站不迷路。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://vipmvpda.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '丝袜小说精选合集',
  url: 'https://vipmvpda.cn',
  description: '丝袜小说频道汇聚海量精品原创故事，涵盖都市言情、青春校园、职场情感等多元题材。',
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="丝袜小说精选合集｜最新热门故事一网打尽"
        description="丝袜小说频道汇聚海量精品原创故事，涵盖都市言情、青春校园、职场情感等多元题材，每日更新最新章节，为喜爱丝袜小说的读者提供极致阅读体验，收藏本站不迷路。"
        keywords="丝袜小说,丝袜小说全集,丝袜小说免费阅读,丝袜小说最新章节,丝袜言情小说,丝袜都市故事,热门丝袜小说推荐"
        canonicalUrl="https://vipmvpda.cn"
        ogImage="https://readdy.ai/api/search-image?query=Elegant%20literary%20atmosphere%20with%20warm%20lighting%2C%20beautiful%20novel%20collection%20display%2C%20sophisticated%20reading%20aesthetic%2C%20warm%20amber%20and%20cream%20tones&width=1200&height=630&seq=og-home&orientation=landscape"
      />
      <script type="application/ld+json">{JSON.stringify(homeJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>

      <main>
        <HeroBanner />
        <CategorySection />
        <FeaturedArticles />
        <LatestUpdates />
        <CTA />
      </main>
    </>
  );
}